import { useHasPermission } from '@hooks';
import { Permission } from '@common/utils/admin_permissions';
import { Navigate } from 'react-router-dom';
import DashboardV2 from '@DashboardV2/pages/DashboardPage';
import { routes } from '@AccessFlows/routes';

export function HomePage() {
  const hasDashboardPermission = useHasPermission([Permission.DASHBOARD_READ]);

  if (!hasDashboardPermission) {
    return <Navigate to={routes.AccessFlows.path} replace />;
  }

  return <DashboardV2 />;
}
